import { render, staticRenderFns } from "./Landing.html?vue&type=template&id=1e4313a4&scoped=true&"
import script from "./Landing.ts?vue&type=script&lang=ts&"
export * from "./Landing.ts?vue&type=script&lang=ts&"
import style0 from "./Landing.scss?vue&type=style&index=0&id=1e4313a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4313a4",
  null
  
)

export default component.exports